import { useDrawingStore } from "@/stores/drawingStore";
import { getDrawingToolIconComponent } from "@/components/icons/drawing-icons";
import { TOOL_LABELS } from "@/lib/lytick/drawingToolDefinitions";

export function ActiveToolBreadcrumb() {
  const activeTool = useDrawingStore((state) => state.activeTool);
  if (!activeTool) return null;

  const Icon = getDrawingToolIconComponent(activeTool);
  const label = TOOL_LABELS[activeTool] ?? activeTool;

  return (
    <div
      aria-label={`Active tool: ${label}`}
      style={{
        position: "absolute",
        top: 10,
        right: 10,
        display: "flex",
        alignItems: "center",
        gap: 6,
        backgroundColor: "color-mix(in srgb, var(--lyt-bg-surface) 85%, transparent)",
        backdropFilter: "blur(4px)",
        WebkitBackdropFilter: "blur(4px)",
        border: "1px solid var(--lyt-border-default)",
        borderRadius: 6,
        padding: "5px 10px",
        fontSize: 11,
        fontFamily: "var(--font-ui)",
        fontWeight: 500,
        color: "var(--lyt-text-secondary)",
        pointerEvents: "none",
        userSelect: "none",
        zIndex: "var(--z-floating-control)" as never,
      }}
    >
      <Icon className="size-[13px]" />
      <span>{label}</span>
    </div>
  );
}
